import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=c4c0af16&scoped=true&"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c0af16",
  null
  
)

export default component.exports